import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { GUIDE_TITLE, HOW_CEREBRO_WORKS } from '@cerebro-diem/core';
import { useAuthStore } from '../../stores/authStore';
import { markGuideSeen } from '../../services/guide';
import { primaryButton } from '../../components/styles';

/** PARA and GTD in a few bullets, as Cerebro does them. Opened from Settings, and by itself once at first sign-in. */
export default function HowItWorksPage() {
  const userId = useAuthStore((state) => state.user?.id);

  useEffect(() => {
    if (userId) markGuideSeen(userId);
  }, [userId]);

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div className="flex items-center gap-4">
        <BookOpen className="w-8 h-8 text-primary" />
        <h1 className="text-2xl font-bold">{GUIDE_TITLE}</h1>
      </div>
      {HOW_CEREBRO_WORKS.map((section) => (
        <section key={section.title} className="bg-surface rounded-xl p-4 sm:p-6 shadow-sm">
          <h2 className="text-lg font-semibold mb-3">{section.title}</h2>
          <ul className="list-disc pl-5 space-y-2 text-on-surface">
            {section.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </section>
      ))}
      <p className="text-sm text-on-surface-variant">You can open this page again from Settings.</p>
      <Link to="/" className={primaryButton}>
        Go to Today
      </Link>
    </div>
  );
}
